import { render, staticRenderFns } from "./VerificationButton.vue?vue&type=template&id=5e571ffe&"
import script from "./VerificationButton.vue?vue&type=script&lang=js&"
export * from "./VerificationButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports